var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames,on:{"click":_vm.change}},[(_vm.isChecked)?_c('div',{class:_vm.iconClassNames}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t("components_baby_ui_checkbox_checkbox_11")))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }